import React from "react";
import { useFlowNavigation } from "@/hooks/flows/useFlowNavigation";
import ActionCard from '@/components/flows/ActionCard';
import { Button } from "@/components/ui/button";

export default function FlowRender({ flowId}) {
    const {
        pageTitle,
        flowOptions,
        isLoading,
        handleFlowSelection,
        error,
        goBack,
        canGoBack,
    } = useFlowNavigation(flowId);
    
    // console.log(flowOptions)

    

    if (isLoading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen p-4">
                <p className="text-red-500 mb-4">{error}</p>
                <Button onClick={() => window.location.reload()}>Retry</Button>
            </div>
        );
    }

    return (
        <div className="md:px-24">
            {canGoBack && (
                <Button onClick={goBack} variant="outline" className="mb-6">
                    ← Back
                </Button>
            )}

            {pageTitle && (
                <h1 className="mt-16 md:mt-28 lg:mt-32 lg:mb-14 md:mb-14 text-2xl md:text-3xl font-bold mb-8 text-center text-white">{pageTitle}</h1>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4 place-items-center xl:px-40 lg:px-20">
                {flowOptions.map((option) => (
                    <ActionCard
                        key={option.id}
                        title={option.title}
                        desc={option.description}
                        imageUrl={`${option.imageUrl}`}
                        onClick={() => handleFlowSelection(option)}
                    />
                ))}
            </div>
        </div>
    );
}